
<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" scrollable no-close-on-esc no-close-on-backdrop>
                <administrative-level-create-or-update v-model="administrativeLevel" :errors="errors"></administrative-level-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        name="administrativeLevel"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import AdministrativeLevelCreateOrUpdate from './components/AdministrativeLevelCreateOrUpdate.vue'
import HRParametersApi from '@/api/human-resources-parameters'
export default {
    components:{
        BCard,
        AdministrativeLevelCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Ad",key:"Name", thClass:"w-10",sortable:true},
                {name:"Grup",key:"AdministrativeLevelGroupName", thClass:"w-20",sortable:true},
                {name:"Çarpan",key:"Multiplier", thClass:"w-30",sortable:true},
                {name:"Açıklama",key:"Description", thClass:"w-40",sortable:true}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            administrativeLevel:{
                Id:null,
                Name:null,
                AdministrativeLevelGroupId:null,
                Multiplier:null,
                Description:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.administrativeLevel.Id = null
            this.administrativeLevel.Name = null
            this.administrativeLevel.AdministrativeLevelGroupId = null
            this.administrativeLevel.Multiplier = null
            this.administrativeLevel.Description = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HRParametersApi.AdministrativeLevel.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.administrativeLevel.Id = item.Id
            this.administrativeLevel.Name = item.Name
            this.administrativeLevel.AdministrativeLevelGroupId = item.AdministrativeLevelGroupId
            this.administrativeLevel.Multiplier = item.Multiplier
            this.administrativeLevel.Description = item.Description
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HRParametersApi.AdministrativeLevel.CreateOrUpdate(this.editing,this.administrativeLevel).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} düzeyini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HRParametersApi.AdministrativeLevel.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>
